export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-ipx-bar/index.js